<tgt-modal [witdhModal]="'40%'">
  <main>
    <div class="header">
      <span>Alterar Senha</span>
    </div>
    <tgt-divider></tgt-divider>

    <div class="form">
      <tgt-input-icon [error]="form.controls.currentPassword.value === '' ? camposObrigatoriosSenha : false" [border]="true" placeholder="Senha Atual" [control]="form.controls.currentPassword" [type]="'password'"></tgt-input-icon>
      <tgt-input-icon [error]="form.controls.password.value === '' ? camposObrigatoriosSenha : false" [border]="true" placeholder="Nova Senha" [control]="form.controls.password" [type]="'password'"></tgt-input-icon>
      <tgt-input-icon [error]="form.controls.passwordConfirmation.value === '' ? camposObrigatoriosSenha : false" [border]="true" placeholder="Confirmar Nova Senha" [control]="form.controls.passwordConfirmation" [type]="'password'"></tgt-input-icon>
    </div>

    <div class="footer">
      <div class="forgot">
        <div class="section">
          <span class="info-label">A senha deve conter:</span>
          <div class="info-detail">
            @if(form.controls.password.value == null) {
            <span class="material-symbols-outlined icone">do_not_disturb_on</span>
            } @else if(this.form.controls.password.value['length'] >= 8) {

            <span class="material-symbols-outlined icone" [style.color]="'#3CCF17'">check_circle</span>
            } @else {

            <span class="material-symbols-outlined icone" [style.color]="'#FA077C'">cancel</span>
            }
            <p>Pelo menos 8 caracteres;</p>
          </div>
          <div class="info-detail">
            @if(this.form.controls.password.value == null && haveUppercaseAndLowwercase == false) {
            <span class="material-symbols-outlined icone">do_not_disturb_on</span>
            } @else if(haveUppercaseAndLowwercase) {
            <span class="material-symbols-outlined icone" [style.color]="'#3CCF17'">check_circle</span>
            } @else {
            <span class="material-symbols-outlined icone" [style.color]="'#FA077C'">cancel</span>
            }
            <p>Letras maiúsculas e minúsculas;</p>
          </div>
          <div class="info-detail">
            @if(this.form.controls.password.value == null && contentNumbers == false) {
            <span class="material-symbols-outlined icone">do_not_disturb_on</span>
            } @else if(contentNumbers) {
            <span class="material-symbols-outlined icone" [style.color]="'#3CCF17'">check_circle</span>
            } @else {
            <span class="material-symbols-outlined icone" [style.color]="'#FA077C'">cancel</span>
            }
            <p>Números;</p>
          </div>
          <div class="info-detail">
            @if(this.form.controls.password.value == null && specialChars == false) {
            <span class="material-symbols-outlined icone">do_not_disturb_on</span>
            } @else if(specialChars) {
            <span class="material-symbols-outlined icone" [style.color]="'#3CCF17'">check_circle</span>
            } @else {
            <span class="material-symbols-outlined icone" [style.color]="'#FA077C'">cancel</span>
            }

            <p>Caracteres especiais.</p>
          </div>
        </div>

      </div>
    </div>

    <div class="buttons">
      <tgt-button fieldButton="outline" class="col-6" [border]="false" [size]="'small'" [type]="'button'"
        (click)="cancelar()">Cancelar</tgt-button>
      <tgt-button color="primary" class="col-6" [size]="'small'" (click)="enviar()">Salvar</tgt-button>
    </div>
  </main>
</tgt-modal>
